<div class="daily-report-container">
  <app-day-selector
    [exportDisabled]="isExportDisabled()"
    [isExporting]="isExporting"
    (dayChanged)="onDayChanged($event)"
    (exportRequested)="onExportRequested()">
  </app-day-selector>

  @if (isWeekend()) {
    <mat-card class="weekend-card">
      <mat-card-content>
        <img src="weekend-rest.svg" alt="Pihenés" class="weekend-image">
        <p>Hétvége – jó pihenést!</p>
      </mat-card-content>
    </mat-card>
  } @else if (hasNoData) {
    <mat-card class="empty-state-card">
      <mat-card-content>
        <mat-icon>info</mat-icon>
        <p>Nincs rögzített adat.</p>
      </mat-card-content>
    </mat-card>
  } @else if (isLoading && !hasLoadedOnce) {
    <mat-card class="loading-card">
      <mat-card-content>
        <p>Napi riport betöltése...</p>
      </mat-card-content>
    </mat-card>
  } @else if (callCenterUsers.length === 0) {
    <mat-card class="empty-state-card">
      <mat-card-content>
        <mat-icon>info</mat-icon>
        <p>Nincs megjeleníthető Call Center munkatárs.</p>
      </mat-card-content>
    </mat-card>
  } @else {
    <div class="tables" [class.reloading]="isLoading">
      @for (user of callCenterUsers; track user.id) {
        <app-daily-report-table
          [title]="user.username || user.name || 'Ismeretlen'"
          [dayInfo]="selectedDay"
          [cells]="cellsByUser[user.id] || []">
        </app-daily-report-table>
      }

      @if (showSummaryTable()) {
        <app-daily-report-table
          title="Összesen"
          [dayInfo]="selectedDay"
          [cells]="allCells">
        </app-daily-report-table>
      }
    </div>
  }
</div>
